// src/contracts/ui/UiToastBus.ts
//
// UiToastBus v1 (window event bridge)
// ----------------------------------
// Purpose:
// - Allow any surface (including MobileShell / nav) to request a toast
// - Without importing feature-level toast systems (e.g., OmniCine Toaster)
//
// Usage:
//   window.dispatchEvent(new CustomEvent("synk:ui:toast", { detail: { ... } }))
//

export type UiToastTone = "info" | "ok" | "warn" | "bad";

export type UiToastV1 = {
  v: 1;
  id?: string; // optional correlation id
  tone?: UiToastTone;
  title?: string;
  message: string;
  ms?: number; // display duration
  source?: string; // e.g. "mobile-nav"
};

export const UI_TOAST_EVENT = "synk:ui:toast";

export function emitUiToast(toast: Omit<UiToastV1, "v"> & { v?: 1 }) {
  const detail: UiToastV1 = {
    v: 1,
    tone: toast.tone ?? "info",
    title: toast.title,
    message: toast.message,
    ms: toast.ms ?? 2200,
    id: toast.id,
    source: toast.source,
  };

  window.dispatchEvent(new CustomEvent<UiToastV1>(UI_TOAST_EVENT, { detail }));
}
